import { appSettings } from "@/app.settings";
import Vue from "vue";
import Vuex from "vuex";
import { INIT_AFTER_CALLBACK, SIGN_OUT, SET_LOCALE } from "./mutations";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      id: "",
      name: "",
      locale: "",
      permissions: []
    },
    idToken: "",
    sid: ""
  },
  getters: {
    username: state => {
      return state.user.name;
    },
    isAuthenticated: state => {
      if (state.user.name) {
        return true;
      }
      return false;
    },
    userId: state => {
      return state.user.id;
    },
    locale: state => {
      return state.user.locale;
    },
    session_id: state => {
      return state.sid;
    },
    canPersonalDataView: state => {
      if (appSettings.verifyPermissions) {
        return state.user.permissions ? state.user.permissions.includes('user.personalData.canView') : false;
      }
      return true;
    },
    canPersonalDataEdit: state => {
      if (appSettings.verifyPermissions) {
        return state.user.permissions ? state.user.permissions.includes('user.personalData.canEdit') : false;
      }
      return true;
    }
  },
  mutations: {
    [INIT_AFTER_CALLBACK](state, data) {
      state.user.id = data.profile.sub;
      state.user.name = data.profile.preferred_username;
      state.user.locale = data.profile.locale;
      if (appSettings.verifyPermissions && data.profile.permissions) {
        const permissions = data.profile.permissions.filter(r => r.resource_id === data.profile.aud || r.resource_id == data.profile.client_id);
        if (permissions && permissions.length > 0) {
          state.user.permissions = permissions[0].resource_scopes;
        }
      }
      state.idToken = data.id_token;
      state.sid = data.profile.sid;
      axios.defaults.headers.common["Authorization"] =
        "bearer " + data.access_token;
    },
    [SIGN_OUT](state) {
      state.user.name = "";
      axios.defaults.headers.common["Authorization"] = "";
      state.id_token = "";
      state.sid = "";
    },
    [SET_LOCALE](state, locale) {
      state.user.locale = locale;
    }
  },
  actions: {
    setUser(context, data) {
      context.commit(INIT_AFTER_CALLBACK, data);
    },
    removeUser(context) {
      context.commit(SIGN_OUT);
    },
    setLocale(context, locale) {
      context.commit(SET_LOCALE, locale);
    }
  }
});
